import { I18nProvider } from "./i18n";
import { Navbar } from "./components/navbar";
import { Hero } from "./components/hero";
import { LogoMarquee } from "./components/logo-marquee";
import { Products } from "./components/central";
import { Services } from "./components/services";
import { Process } from "./components/process";
import { WhyVorto } from "./components/why-vorto";
import { Security } from "./components/security";
import { CaseStudy } from "./components/case-study";
import { Faq } from "./components/faq";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";

/** O site inteiro — uma página, nove seções, três idiomas. */
export function App() {
  return (
    <I18nProvider>
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <Products />
        <Services />
        <Process />
        <WhyVorto />
        <Security />
        <CaseStudy />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </I18nProvider>
  );
}
